<app-header [subTitle]="''"></app-header>

<div class="review-container" *ngIf="!submitted; else thankYouTemplate">
  <mat-card class="review-card">
    <!-- Clinic Logo, Name, and Address -->
    <mat-card-header>
      <img mat-card-avatar src="assets/client-logo.png" alt="Clinic Logo" class="clinic-logo">
      <mat-card-title class="clinic-name">{{ appConfig.displayName }}</mat-card-title>
      <mat-card-subtitle class="context-info">{{ appConfig.address }}</mat-card-subtitle>
    </mat-card-header>

    <!-- Feedback Form Section -->
    <mat-card-content>
      <h2>We Value Your Feedback!</h2>
      <p>
        Thank you for visiting our clinic! We'd love to hear your thoughts on your recent appointment. Your feedback helps us improve our services and provide the best possible care.
      </p>

      <form [formGroup]="reviewForm" (ngSubmit)="onSubmit()">
        <!-- Rating Selector with Clickable Stars -->
        <div class="star-rating">
          <mat-icon
            *ngFor="let star of [1, 2, 3, 4, 5]"
            [ngClass]="{'filled': star <= (reviewForm.get('rating')?.value || 0)}"
            (click)="setRating(star)"
            class="star-icon">
            {{ star <= (reviewForm.get('rating')?.value || 0) ? 'star' : 'star_outline' }}
          </mat-icon>
        </div>

        <!-- Comment/Feedback -->
        <mat-form-field appearance="fill">
          <mat-label>Additional Comments (Optional)</mat-label>
          <textarea matInput formControlName="comment" placeholder="Tell us what you liked or what we can improve"></textarea>
        </mat-form-field>

        <!-- Submit Button -->
        <mat-card-actions align="end">
          <button mat-raised-button color="primary" type="submit" [disabled]="!reviewForm.valid || loading">
            <mat-progress-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-progress-spinner>
            Submit Review
          </button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #thankYouTemplate>
  <div class="review-container">
    <mat-card class="thank-you-card">
      <mat-card-title>Thank You!</mat-card-title>
      <mat-card-content>
        <h2>Your feedback has been submitted.</h2>
        <p>We appreciate your time and effort in helping us improve our services.</p>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>

